<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-cast-education
            </v-icon>
            <span class="title">Data Prodi</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Prodi
              <v-icon large>mdi-cast-education</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="5">
                        <v-autocomplete
                          v-model="filter.jurusan"
                          :items="listjurusan"
                          item-value="id_jur"
                          item-text="nama_jur"
                          label="Jurusan"
                          return-object
                          @change="getProdi">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editProdi(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              @click="deleteProdi(item)"
                              small
                              icon>
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddprodi"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-model="addprodi.jur"
                                :items="listjurusanadd"
                                :rules="[rules.required]"
                                item-value="id_jur"
                                item-text="nama_jur"
                                label="Jurusan"
                                return-object>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                class="text-uppercase-input"
                                v-model="addprodi.nama_prodi"
                                :rules="[rules.required]"
                                label="Nama Prodi"
                                name="nama_prodi"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                :loading="loading.addprodi"
                                :disabled="loading.addprodi || !formadd.valid"
                                large
                                block
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.prodi"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-if="dmodaldata.prodi">
      <v-card>
        <v-toolbar :color="maincolor" dark class="px-md-5" flat>
          <v-toolbar-title>
            Update data prodi
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dmodal.prodi = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-row justify="center" class="black--text py-5">
              <v-col cols="12" md="11">
                <v-card outlined rounded="lg">
                  <v-card-text>
                    <v-form
                      @submit.prevent="submitUpdate"
                      ref="formupdateprodi"
                      v-model="formupdate.valid"
                      lazy-validation>
                      <v-row justify="center">
                        <v-col cols="12" md="8">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-model="dmodaldata.prodi.id_jur"
                                :items="listjurusanadd"
                                :rules="[rules.required]"
                                item-value="id_jur"
                                item-text="nama_jur"
                                label="Jurusan">
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="dmodaldata.prodi.nama_prodi"
                                :rules="[rules.required]"
                                label="Nama Prodi"
                                name="namaprodi"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="dmodaldata.prodi.slug_prodi"
                                :rules="[rules.required]"
                                label="Slug page"
                                name="slug"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="dmodaldata.prodi.web_prodi"
                                :rules="[rules.required]"
                                label="Website"
                                name="website"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea
                                name="prev"
                                label="Preview info (Max 300 Karakter)"
                                placeholder="Tuliskan preview info disini..."
                                counter
                                rows="3"
                                v-model="dmodaldata.prodi.desc_prodi"
                                :rules="[rules.required, rules.textlimit]">
                              </v-textarea>
                            </v-col>
                            <v-col cols="12">
                              <vue-editor
                                v-model="dmodaldata.prodi.content_prodi"
                                placeholder="Tuliskan isi info disini..."
                                :rules="[rules.required]">
                              </vue-editor>
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                :items="liststatus"
                                name="statusprodi"
                                v-model="dmodaldata.prodi.status_prodi"
                                label="Status">
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-row>
                            <v-col cols="12">
                              <v-img
                                v-if="dmodaldata.prodi.img_prodi"
                                :lazy-src="require('../../assets/default.jpg')"
                                :src="api + '/upload/jurusan/' + dmodaldata.prodi.img_prodi"
                                contain>
                              </v-img>
                              <v-img
                                v-if="!dmodaldata.prodi.img_prodi"
                                :lazy-src="require('../../assets/default.jpg')"
                                :src="require('../../assets/default.jpg')"
                                contain>
                              </v-img>
                            </v-col>
                            <v-col cols="12">
                              <v-file-input
                                v-model="dmodaldata.prodi.img_prodinew"
                                :rules="rules.files"
                                accept=".png, .jpg, .jpeg"
                                name="fileresume"
                                placeholder="Select file"
                                label="Image Thumbnail (max. 500 Kb)"
                                show-size
                                prepend-icon="mdi-camera">
                              </v-file-input>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <alertsp :alertdata="alertupdate"></alertsp>
                              <v-btn
                                :loading="loading.editprodi"
                                :disabled="loading.editprodi || !formupdate.valid"
                                block
                                large
                                :color="maincolor"
                                dark
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- dialog delete -->
    <v-dialog
      v-model="dmodal.delprodi"
      max-width="450px"
      persistent>
      <v-card v-if="dmodaldata.delprodi">
        <v-alert
          icon="mdi-comment-question-outline"
          prominent
          text
          type="warning">
          Are you sure that you want to permanently delete your prodi <b>{{ dmodaldata.delprodi.nama_prodi }}</b>?
        </v-alert>
        <div class="mx-3">
          <alertsp :alertdata="alertupdate"></alertsp>
        </div>
        <v-card-actions class="justify-center">
          <v-btn
            small
            depressed
            color="grey darken-1"
            class="white--text"
            @click="dmodal.delprodi = false">
            No
          </v-btn>
          <v-btn
            small
            depressed
            color="error"
            :loading="loading.delprodi"
            :disabled="loading.delprodi"
            @click="deleteProdiconfirm(dmodaldata.delprodi.id_prodi)">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'ProdiAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      addprodi: false,
      editprodi: false,
      delprodi: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
      status: 'active',
      jurusan: '',
    },
    headers: [
      { text: 'Nama Prodi', value: 'nama_prodi' },
      { text: 'Jurusan', value: 'nama_jur' },
      { text: 'Status', value: 'status_prodi' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addprodi: {
      jur: '',
      nama_prodi: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 300 || 'Max 300 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    listjurusan: [],
    listjurusanadd: [],
    dmodal: {
      prodi: false,
      delprodi: false,
    },
    dmodaldata: {
      prodi: null,
      delprodi: null,
    },
    varsemua: 'Semua',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJurusan();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJurusan() {
      if (this.tokenscr) {
        this.listjurusan = [];
        this.listjurusanadd = [];
        this.axios
          .get(
            this.api + '/api/jurusan/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // kelurahan
                this.listjurusan = resdata.data;
                this.listjurusanadd = JSON.parse(JSON.stringify(resdata.data));
                this.listjurusan.push({ nama_jur: this.varsemua });
                this.filter.jurusan = this.listjurusan[0];
                // get banjar
                this.getProdi();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getProdi() {
      if (this.tokenscr) {
        this.datalist = [];
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/prodi/',
            {
              params: {
                idpos: this.filter.jurusan.id_jur,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddprodi.validate()) {
        // console.log(this.addprodi);
        if (this.tokenscr) {
          this.loading.addprodi = true;
          this.axios
            .post(
              this.api + '/api/prodi/',
              qs.stringify(
                {
                  nama_prodi: this.addprodi.nama_prodi,
                  id_jur: this.addprodi.jur.id_jur,
                },
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  // this.$refs.formaddprodi.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Banjar "' + resdata.data + '" berhasil ditambahkan!';
                  this.getProdi();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addprodi = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addprodi = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    editProdi(item) {
      this.alertupdate.show = false;
      this.dmodal.prodi = true;
      this.dmodaldata.prodi = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdateprodi.validate()) {
        if (this.tokenscr) {
          // console.log(this.dmodaldata);
          this.loading.editprodi = true;
          const dataadd = this.dmodaldata.prodi;
          const formData = new FormData();
          formData.append('id_prodi', dataadd.id_prodi);
          formData.append('id_jur', dataadd.id_jur);
          formData.append('slug_prodi', dataadd.slug_prodi);
          formData.append('web_prodi', dataadd.web_prodi);
          formData.append('desc_prodi', dataadd.desc_prodi);
          formData.append('content_prodi', dataadd.content_prodi);
          formData.append('img_prodi', dataadd.img_prodi);
          formData.append('nama_prodi', dataadd.nama_prodi);
          formData.append('img_prodinew', dataadd.img_prodinew);
          formData.append('status_prodi', dataadd.status_prodi);
          this.axios
            .post(
              this.api + '/api/prodi/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.prodi.nama_prodi + '" berhasil diubah!';
                  this.getProdi();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editprodi = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editprodi = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    deleteProdi(item) {
      this.dmodal.delprodi = true;
      this.dmodaldata.delprodi = JSON.parse(JSON.stringify(item));
      this.alertupdate.show = false;
    },
    deleteProdiconfirm(item) {
      if (this.tokenscr) {
        this.alertupdate.show = false;
        this.loading.delprodi = true;
        this.axios
          .delete(
            this.api + '/api/prodi/' + item,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.delprodi = false;
                this.dmodaldata.delprodi = null;
                this.getProdi();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.delprodi = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.delprodi = false;
          });
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
